import { DateCell, TimeCell, DateTimeCell } from 'components/DataTableTest'

export const dxOrderCols = ({ t, locales }) => [
	{
		caption: 'id',
		dataField: 'id',
		width: 'auto',
		visible: false
	},
	{
		caption: t('common.fields.date'),
		dataField: 'dateOrder',
		width: 110,
		cellRender: DateCell({ locales })
	},
	{
		caption: t('common.strings.branch'),
		dataField: 'shopName',
		width: 'auto'
	},
	{
		caption: t('common.fields.type'),
		dataField: 'orderTypeName',
		cellRender: val => val?.cell?.value || t('common.strings.credit_customer'),
		width: 110
	},
	{
		id: 'receiveDate',
		caption: t('statistic_section.strings.created'),
		dataField: 'dateReceive',
		width: 150,
		cellRender: DateTimeCell({ locales })
	},
	{ caption: t('common.strings.customer'), dataField: 'creditClientName' },
	{ caption: t('common.fields.cash_register'), dataField: 'cashRegisterName', id: 'cashRegisterName', visible: false },
	{ caption: t('statistic_section.strings.employee'), dataField: 'userName', id: 'userName', visible: false },
	{
		id: 'sendDate',
		caption: t('statistic_section.strings.registration_date'),
		dataField: 'dateSend',
		cellRender: DateCell({ locales }),
		visible: false
	},
	{
		id: 'sendTime',
		caption: t('statistic_section.strings.registration_time'),
		dataField: 'dateSend',
		cellRender: TimeCell({ locales }),
		visible: false
	},
	{ caption: t('statistic_section.strings.delivery_note_num'), dataField: 'deliveryNoteNumber', id: 'deliveryNoteNumber', visible: false },
	{ caption: t('statistic_section.strings.delivery_note_num_fa'), dataField: 'importNumber', id: 'importNumber', visible: false }
]

export const dxOrderItemsCols = t => [
	{ caption: t('common.fields.code'), dataField: 'product.code', width: 125 },
	{ caption: t('common.fields.quantity'), dataField: 'amount', width: 125 },
	{ caption: t('common.fields.name'), dataField: 'product.name' }
]

/*
	export const orderCols = ({ t, locales }) => [
		{ Header: 'id', accessor: 'id', show: false, isVisible: false },
		{
			Header: t('common.fields.date'),
			accessor: 'dateOrder',
			Cell: DateCell({ locales }),
			width: 110
		},
		{ Header: t('common.strings.branch'), accessor: 'shopName' },
		{
			Header: t('common.fields.type'),
			accessor: 'orderTypeName',
			Cell: val => val?.cell?.value || t('common.strings.credit_customer')
		},
		{
			id: 'receiveDate',
			Header: t('statistic_section.strings.created'),
			accessor: 'dateReceive',
			Cell: DateCell({ locales }),
			width: 110
		},
		{
			id: 'receiveTime',
			Header: t('common.fields.time'),
			accessor: 'dateReceive',
			Cell: TimeCell({ locales }),
			width: 90
		},
		{ Header: t('common.strings.customer'), accessor: 'creditClientName' },
		{ Header: t('common.fields.cash_register'), accessor: 'cashRegisterName', id: 'cashRegisterName', isVisible: false },
		{ Header: t('statistic_section.strings.employee'), accessor: 'userName', id: 'userName', isVisible: false },
		{
			id: 'sendDate',
			Header: t('statistic_section.strings.registration_date'),
			accessor: 'dateSend',
			Cell: DateCell({ locales }),
			isVisible: false
		},
		{
			id: 'sendTime',
			Header: t('statistic_section.strings.registration_time'),
			accessor: 'dateSend',
			Cell: TimeCell({ locales }),
			isVisible: false
		},
		{ Header: t('statistic_section.strings.delivery_note_num'), accessor: 'deliveryNoteNumber', id: 'deliveryNoteNumber', isVisible: false },
		{ Header: t('statistic_section.strings.delivery_note_num_fa'), accessor: 'importNumber', id: 'importNumber', isVisible: false }
	]

	export const orderItemsCols = t => [
		{ Header: t('common.fields.code'), accessor: 'product.code', width: 125 },
		{ Header: t('common.fields.quantity'), accessor: 'amount', width: 125 },
		{ Header: t('common.fields.name'), accessor: 'product.name', width: 'auto' }
	]
*/

